import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/github/workspace/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "ui-elements"
    }}>{`UI Elements`}</h1>
    <p>{`Messaging extension provides the following UI elements that act as building blocks for creating templated content cards:`}</p>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "./aeptext.md"
        }}>{`AEPText`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "./aepbutton.md"
        }}>{`AEPButton`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "./aepimage.md"
        }}>{`AEPImage`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "./aepstack.md"
        }}>{`AEPStack`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "./aepdismissbutton.md"
        }}>{`AEPDismissButton`}</a></li>
    </ul>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      